<template>

    <div class="af3-floor-plan-card">
      
      <!-- Floor Plan Image Section -->
      <div class="af3-floor-plan-card-image" v-if="floor_plan.image"> 


        <!-- <img :src="floor_plan.image.url" :alt="floor_plan.image.alt" /> -->

        <floorPlanGalleryComponent v-if="options.floor_plans_loop_show_gallery" :floorplan_gallery="floor_plan.floorplan_gallery" :options="options" />
        <img v-else :src="floor_plan.image.url" :alt="floor_plan.image.alt" />

        <!-- Special Text Overlay -->
        <div class="af3-floor-plan-card-special-text" v-if="floor_plan.current_special_text">
          {{ floor_plan.current_special_text }}
        </div>
       
      </div>
      
      <!-- Floor Plan Details Section -->
      <div class="af3-floor-plan-card-metadata">
        <!-- Title and Basic Info -->
        <div class="af3-floor-plan-card-metadata-title">
          <h6 v-html="floor_plan.title"></h6>
          
          <!-- Unit Details -->
          <div class="af3-floor-plan-card-metadata-details">
            <span>{{ bedrooms_string(floor_plan.bedrooms) }}</span> | 
            <span>{{ floor_plan.bathrooms }} {{options.floor_plans_loop_bathrooms_label}}</span> | 
            <span>{{ floor_plan.size_max }} {{options.floor_plans_loop_square_feet_label}}</span>
          </div>

          <!-- Availability Status -->
          <div class="af3-floor-plan-card-metadata-availability" 
               v-if="floor_plan.is_sold_out && options.floor_plans_loop_show_sold_out_flag">
            <span>{{ options.floor_plans_loop_sold_out_label }}</span>
          </div>
        </div>  

        <!-- Price Display -->
         <div class="af3-floor-plan-card-metadata-price-container" v-if="options.floor_plans_loop_show_pricing">
            <!-- Hide the price block entirely when there's no override text and no valid
                 price (e.g. 0 or Yardi's -1 sentinel), so we never render "$0" / "-$1".
                 The container stays so the CTA buttons still render. -->
            <div class="af3-floor-plan-card-metadata-price" v-if="pricingOverrideText || hasValidPrice">
              <template v-if="pricingOverrideText">
                <p>{{ pricingOverrideText }}</p>
              </template>
              <template v-else>
                <p>{{ selected_lease_term ? 'Rent' : 'Starting at' }}</p>
                <span v-dollar-format="displayPrice"></span>
              </template>
            </div>
            <div class="af3-floor-plan-card-metadata-cta-buttons"
                 :class="{ 'af3-floor-plan-card-metadata-cta-buttons-no-price': !pricingOverrideText && !hasValidPrice }">


              

              <div class="af3-floor-plan-card-metadata-cta-button-details-container">
                <template v-if="floor_plan.virtual_tour_url">
                  <button type="button" 
                          @click.stop.prevent="openVrTourModal" 
                          class="af3-floor-plan-card-metadata-cta-button-details" 
                          aria-label="View Virtual Tour">
                    <span>{{ options.floor_plans_loop_virtual_tour_button_label }}</span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 62.98 62.98" fill="currentColor" aria-hidden="true"><path d="M34.05,0a.68.68,0,0,0,.22.09,27,27,0,0,1,4.46.69A29.59,29.59,0,0,1,45.12,3a31.08,31.08,0,0,1,5.52,3.41,30.6,30.6,0,0,1,4.15,3.81,31.75,31.75,0,0,1,4.42,6.24,33.47,33.47,0,0,1,2.07,4.71,31.82,31.82,0,0,1,1.39,5.7,33.53,33.53,0,0,1,.24,6.79,31.38,31.38,0,0,1-3,11.41,32.61,32.61,0,0,1-3.46,5.63,35,35,0,0,1-3.78,4.1,28.37,28.37,0,0,1-4.91,3.66,31.84,31.84,0,0,1-6,2.82A30.37,30.37,0,0,1,36,62.69a22.12,22.12,0,0,1-3.9.28c-.43,0-.86,0-1.29,0a28.85,28.85,0,0,1-6.48-.77,30.48,30.48,0,0,1-6.51-2.28,31.69,31.69,0,0,1-9.63-7.18c-.8-.9-1.55-1.85-2.28-2.81A27.2,27.2,0,0,1,3.1,45.21a31.52,31.52,0,0,1-1.63-4.1,37.29,37.29,0,0,1-1.18-5C.2,35.56.21,35,.13,34.42A24.65,24.65,0,0,1,0,30.68,28.27,28.27,0,0,1,.8,24.26,29.73,29.73,0,0,1,3,17.85,32.61,32.61,0,0,1,6.5,12.22,36.93,36.93,0,0,1,9.75,8.63,29.23,29.23,0,0,1,15.29,4.4a32.33,32.33,0,0,1,5.93-2.77A34.82,34.82,0,0,1,26.92.25C27.46.16,28,.15,28.56.1A2.56,2.56,0,0,0,28.9,0ZM13.42,17.09c-.83.44-1.67.85-2.48,1.33a23.63,23.63,0,0,0-4.09,3,16.82,16.82,0,0,0-3.19,3.94A11.91,11.91,0,0,0,2,30.81c0,.51,0,1,0,1.52a10.23,10.23,0,0,0,.17,1.45A14.34,14.34,0,0,0,6,40.66a23.53,23.53,0,0,0,5.21,4.05c.72.43,1.49.77,2.23,1.14l.05,0-.05,0c0-.2-.07-.4-.12-.6-.13-.43-.28-.85-.39-1.29a38.18,38.18,0,0,1-1.13-5.61c-.14-1.4-.4-2.79-.43-4.19A53.1,53.1,0,0,1,11.41,28c.13-1.46.27-2.92.51-4.36a43.08,43.08,0,0,1,1-4.77c.17-.59.31-1.18.47-1.77l0-.05ZM45.85,13.4l0,0,0,0c-.31-.62-.61-1.24-.93-1.85A24.22,24.22,0,0,0,41.69,7a16.07,16.07,0,0,0-5.58-4.12A11.46,11.46,0,0,0,29.89,2a11.64,11.64,0,0,0-4.47,1.59,18,18,0,0,0-5.42,5c-.38.51-.72,1-1.09,1.56a1,1,0,0,1-1,.42,1,1,0,0,1-.77-.71,1,1,0,0,1,.2-.93,24.92,24.92,0,0,1,3.06-3.81L21.91,3.7a1.39,1.39,0,0,0,.15-.19,1.64,1.64,0,0,0-.22,0,25.28,25.28,0,0,0-4.43,1.93,27.1,27.1,0,0,0-4.18,2.78c-.63.52-1.25,1-1.85,1.61-.73.71-1.46,1.42-2.15,2.18s-1.05,1.3-1.56,2a26.68,26.68,0,0,0-2.21,3.46,26.12,26.12,0,0,0-1.9,4.38.81.81,0,0,0,0,.22,1.37,1.37,0,0,0,.18-.16c.21-.24.4-.51.64-.74.76-.74,1.5-1.5,2.33-2.17a30.9,30.9,0,0,1,2.89-2.06,27.9,27.9,0,0,1,4.13-2.15c1.13-.46,2.26-.94,3.42-1.32s2.51-.71,3.77-1a33.66,33.66,0,0,1,4.45-.77c.48-.06,1-.1,1.46-.14.83-.08,1.66-.2,2.49-.22a49.82,49.82,0,0,1,8.37.36c.93.14,1.87.21,2.78.41,1.62.37,3.23.82,4.85,1.23Zm3.68,32.46,1.15-.58a24.68,24.68,0,0,0,5.37-3.73,16.14,16.14,0,0,0,4-5.51,12.69,12.69,0,0,0,1-4.59,10.32,10.32,0,0,0-.23-2.06,12.44,12.44,0,0,0-2.26-5.17,15.34,15.34,0,0,0-3.12-3.36c-.94-.73-1.87-1.46-2.86-2.11a25.77,25.77,0,0,0-4.22-2.23,33.43,33.43,0,0,0-3.2-1.22,44.87,44.87,0,0,0-6.06-1.44c-1.53-.24-3.06-.44-4.6-.53-1.22-.08-2.44-.11-3.67-.07-1.51.05-3,.07-4.51.27-1,.15-2.07.23-3.09.41a41.91,41.91,0,0,0-6.78,1.83.93.93,0,0,0-.64.65c-.38,1.31-.8,2.61-1.17,3.92a25.39,25.39,0,0,0-.83,4.13c-.07.67-.17,1.34-.24,2a23.65,23.65,0,0,0-.22,2.38c0,1.28-.13,2.56,0,3.85.06.81.09,1.63.12,2.44.05,1.12.22,2.23.37,3.34a41.11,41.11,0,0,0,.84,4.26,33.45,33.45,0,0,0,1.83,5.44,26,26,0,0,0,3,5.41,30.08,30.08,0,0,0,2,2.5,16.38,16.38,0,0,0,5.13,3.83,11.47,11.47,0,0,0,6.49,1,12.16,12.16,0,0,0,5.46-2.21A18,18,0,0,0,42,55.56a28.18,28.18,0,0,0,3.86-6l0,0,0,0-.36.07c-1.3.34-2.59.72-3.9,1-1,.23-2,.38-3.06.54-.75.11-1.5.19-2.25.26a24.37,24.37,0,0,1-2.55.22,51.39,51.39,0,0,1-5.82-.1c-.69-.08-1.39-.06-2.07-.16-1.23-.17-2.46-.38-3.68-.6a15.34,15.34,0,0,1-1.66-.37,1,1,0,0,1,.29-1.87,1.94,1.94,0,0,1,.42,0,35.28,35.28,0,0,0,4.33.74c1,.11,2.07.29,3.1.33,1.24,0,2.48.07,3.72,0,1.41,0,2.81-.1,4.22-.24,1.17-.12,2.34-.31,3.5-.51a38.75,38.75,0,0,0,6.59-1.81.63.63,0,0,0,.44-.44c.33-1,.7-2.05,1-3.09.22-.72.39-1.46.54-2.19a33.79,33.79,0,0,0,.75-4.89c.07-1.08.17-2.16.24-3.23q.06-.83.09-1.65c0-.1,0-.2,0-.31,0-1.12-.06-2.25-.06-3.37a.8.8,0,0,1,.85-.79.86.86,0,0,1,1,.68,3.54,3.54,0,0,1,.11.85c0,2.09.13,4.17-.07,6.26-.12,1.17-.22,2.35-.38,3.52a41,41,0,0,1-.94,4.79c-.22.87-.46,1.74-.69,2.61l0,0ZM59.44,41l-.06-.08s-.1.07-.13.12a21.26,21.26,0,0,1-2.73,2.72,25.82,25.82,0,0,1-4.66,3.16c-.94.5-1.9.94-2.87,1.38a1.4,1.4,0,0,0-.71.71c-.61,1.27-1.21,2.55-1.9,3.77a23.07,23.07,0,0,1-4,5.21c-.45.44-.93.86-1.39,1.29a.75.75,0,0,0-.13.18l.23,0a26.47,26.47,0,0,0,6-2.83,30.89,30.89,0,0,0,4.55-3.52,30.53,30.53,0,0,0,2.94-3.19,27.81,27.81,0,0,0,2.73-4.07,26.34,26.34,0,0,0,2.06-4.64C59.39,41.09,59.42,41,59.44,41ZM3.59,40.91H3.53a.88.88,0,0,0,0,.17,27.88,27.88,0,0,0,2.85,6,28.08,28.08,0,0,0,4.19,5.26,27.6,27.6,0,0,0,3.64,3.1,28.85,28.85,0,0,0,7.17,3.8l.64.19L21.59,59,21,58.46a24.78,24.78,0,0,1-3.28-3.87,31.21,31.21,0,0,1-2.18-3.7c-.26-.55-.55-1.1-.77-1.67a1.9,1.9,0,0,0-1.08-1.07c-1.18-.55-2.37-1.12-3.5-1.76A23.28,23.28,0,0,1,3.66,41ZM41,3.49l-.09,0,0,.05.14.13a20.53,20.53,0,0,1,3.12,3.2,26.67,26.67,0,0,1,3.13,5c.36.73.7,1.48,1,2.22a.9.9,0,0,0,.45.47c.36.15.7.35,1.06.5a27.62,27.62,0,0,1,5.35,3.08,15,15,0,0,1,1.52,1.24c.81.77,1.59,1.58,2.39,2.37l.29.28c0-.13,0-.27-.08-.4a26.71,26.71,0,0,0-2.25-4.89,27.45,27.45,0,0,0-3.88-5.27c-.54-.56-1.08-1.12-1.65-1.64S50.14,8.53,49.38,8a30.88,30.88,0,0,0-7.24-4.07C41.76,3.73,41.36,3.62,41,3.49Z"/><path d="M44.88,31.49c0,.74,0,1.47,0,2.21a4.36,4.36,0,0,1-8.59,1.11,5.45,5.45,0,0,1-.15-1.34c0-1.35,0-2.7,0-4a4.44,4.44,0,0,1,1.69-3.64,4.24,4.24,0,0,1,4.6-.49,4.28,4.28,0,0,1,2.4,3.14,3.6,3.6,0,0,1,.06.66c0,.8,0,1.6,0,2.4Zm-2,0c0-.8,0-1.6,0-2.4a2.38,2.38,0,0,0-2.23-2.26,2.41,2.41,0,0,0-2.53,2.41c0,1.48,0,3,0,4.43a2.42,2.42,0,0,0,3,2.4,2.47,2.47,0,0,0,1.77-2.18C42.85,33.07,42.89,32.27,42.89,31.47Z"/><path d="M25.89,32.1c.06-.9.07-1.78.18-2.65a5,5,0,0,1,1-2.35,5.33,5.33,0,0,1,3-2.06,6.63,6.63,0,0,1,1.26-.21,1,1,0,1,1,.14,2,6.73,6.73,0,0,0-.9.13A3.45,3.45,0,0,0,28,29.88S28,30,28,30s.11,0,.15,0a4.55,4.55,0,0,1,2.34-.61,4.38,4.38,0,0,1,4,2.87,4.28,4.28,0,0,1-1,4.54A4.06,4.06,0,0,1,31.26,38a4.33,4.33,0,0,1-4.45-1.68,3.48,3.48,0,0,1-.75-1.92C26,33.63,26,32.86,25.89,32.1Zm6.81,1.62a2.35,2.35,0,0,0-2.41-2.37,2.38,2.38,0,0,0-2.35,2.4,2.45,2.45,0,0,0,2.38,2.39A2.4,2.4,0,0,0,32.7,33.72Z"/><path d="M24.51,28.79a3.38,3.38,0,0,1-1,2.39c-.26.29-.26.3,0,.59a3.63,3.63,0,0,1-.68,5.62,4.32,4.32,0,0,1-5.49-.6A1.68,1.68,0,0,1,17,36.1a.87.87,0,0,1,.48-1,.84.84,0,0,1,1,.07c.22.15.42.33.63.5a2.34,2.34,0,0,0,3-.23A1.67,1.67,0,0,0,21.87,33a2.21,2.21,0,0,0-1.3-.48,1.72,1.72,0,0,1-.58-.15.93.93,0,0,1,0-1.7,2.71,2.71,0,0,1,.64-.15,2,2,0,0,0,1.87-1.59,1.5,1.5,0,0,0-.42-1.4,2.35,2.35,0,0,0-3-.24l-.53.42a.91.91,0,0,1-1.32-.05,1,1,0,0,1,0-1.33A4,4,0,0,1,19.31,25a4.21,4.21,0,0,1,3.66.69A3.53,3.53,0,0,1,24.51,28.79Z"/><path d="M44.1,22.41a3.19,3.19,0,0,1,3.21-3.23,3.23,3.23,0,0,1,3.23,3.3,3.22,3.22,0,1,1-6.44-.07Zm4.44,0a1.21,1.21,0,0,0-1.24-1.24A1.29,1.29,0,0,0,46,22.41a1.36,1.36,0,0,0,1.3,1.29A1.28,1.28,0,0,0,48.54,22.4Z"/></svg>
                  </button>
                </template>

              </div>


              <div class="af3-floor-plan-card-metadata-cta-button-details-container" v-if="options.floor_plans_loop_link_floorplans">
                <a :href="floor_plan.link_floorplan" class="af3-floor-plan-card-metadata-cta-button-details">
                  <span>{{options.floor_plans_loop_view_details_button_label}}</span>
                  <svg xmlns="http://www.w3.org/2000/svg" width="23.274" height="20.617" viewBox="0 0 23.274 20.617"><g transform="translate(0 -0.002)"><path d="M12.968,20.619a1,1,0,0,1-.707-1.707l7.6-7.6H1a1,1,0,0,1,0-2H19.864l-7.6-7.6A1,1,0,1,1,13.675.293L22.985,9.6l.022.024h0a1,1,0,0,1,.267.68h0a1,1,0,0,1-.265.675h0c-.009.008-.017.017-.025.025l-9.31,9.31a1,1,0,0,1-.707.293"/></g></svg>
                </a>
              </div>


            </div>
        </div>
      </div>

      <!-- Call-to-Action Buttons (footer of card): internal links open in same tab -->
      <div class="af3-floor-plan-card-cta-buttons">
        <!-- Apply Button -->
        <a v-if="floor_plan.availability_url" 
           :href="floor_plan.availability_url" 
           v-bind="getLinkTargetAndRel(floor_plan.availability_url)">
          {{ options.floor_plans_loop_apply_button_label }}
        </a>

        <!-- Tour Button - Custom Link -->
        <template v-if="options.floor_plans_loop_custom_tour_link">
          <a :href="options.floor_plans_loop_custom_tour_link"
             v-bind="getLinkTargetAndRel(options.floor_plans_loop_custom_tour_link)">
            {{ options.floor_plans_loop_schedule_tour_button_label }}
          </a>
        </template>
        
        <!-- Tour Button - Popup -->
        <template v-else>
          <a v-if="options.tour_popup_enabled" 
             href="#tour-popup" 
             x-data="" 
             x-on:click.prevent="$store.tourPopup.toggle()">
            {{ options.floor_plans_loop_schedule_tour_button_label }}
          </a>
        </template>
      </div>

   
     

    </div>

    <!-- Virtual Tour Modal -->
    <Teleport to="body">
      <div v-if="showVrTourModal" class="af3-vr-tour-modal-overlay" @click="closeVrTourModal">
        <div class="af3-vr-tour-modal-content" @click.stop>
          <button class="af3-vr-tour-modal-close" @click="closeVrTourModal">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
          </button>
          <iframe 
            v-if="floor_plan.virtual_tour_url" 
            :src="floor_plan.virtual_tour_url" 
            class="af3-vr-tour-modal-iframe"
            frameborder="0"
            allowfullscreen
          ></iframe>
        </div>
      </div>
    </Teleport>


  


</template>
  
<script>

import { defineComponent, computed, onMounted, toRaw, ref, Teleport } from 'vue';
import floorPlanGalleryComponent from './FloorPlanGalleryComponent.vue';
import { getLinkTargetAndRel } from '../../utils/linkUtils.js';

export default defineComponent({
    name: 'FloorPlanCardComponent',
    
    components: { floorPlanGalleryComponent, Teleport },
   
    props: {
      floor_plan: {
        type: Object,
        required: true
      },
      options: {
        type: Object,
        required: true
      },
      selected_lease_term: {
        type: String,
        required: false,
        default: ''
      },
      resources_url: {
        type: String,
        required: true
      }
    },

    setup(props) {
      // Virtual Tour Modal State
      const showVrTourModal = ref(false);
      
      const openVrTourModal = () => {
        showVrTourModal.value = true;
        // Prevent body scroll when modal is open
        document.body.style.overflow = 'hidden';
      };
      
      const closeVrTourModal = () => {
        showVrTourModal.value = false;
        // Restore body scroll when modal is closed
        document.body.style.overflow = '';
      };
      
      // Calculate the selected lease option based on the selected_lease_term
      const selectedLeaseOption = computed(() => {
        if (!props.selected_lease_term || !props.floor_plan.lease_options || !props.floor_plan.lease_options.length) {
          return null;
        }
        
        return props.floor_plan.lease_options.find(option => 
          option.composite_key === props.selected_lease_term
        );
      });
      
      // Pricing override from Integrations (or per-floor-plan): show this text instead of numeric price
      const pricingOverrideText = computed(() => {
        const override = props.options.override_pricing || props.floor_plan.has_pricing_override;
        return override && String(override).trim() !== '' ? override : null;
      });

      // Compute the price to display based on selected lease term
      const displayPrice = computed(() => {
        // Check if we have a valid selected lease term that's not empty
        if (props.selected_lease_term && props.selected_lease_term.trim() !== '') {
          // Find the matching lease option
          if (selectedLeaseOption.value) {
            // Convert the rent string to a number
            const rentValue = selectedLeaseOption.value.rent;
            if (rentValue) {
              // Remove commas and other non-numeric characters (except decimal point)
              const cleanedRent = rentValue.replace(/,/g, '');
              // Parse the rent value as a float
              const parsedRent = parseFloat(cleanedRent);
              if (!isNaN(parsedRent)) {
                return parsedRent;
              }
            }
          }
        }
        
        // Fall back to default price_min if no lease term is selected or if "Any" is selected
        return props.floor_plan.price_min;
      });

      // Whether the displayed price is a real positive number worth rendering.
      // Guards against "$0" / "-$1" from empty, zero, or Yardi's -1 sentinel values.
      const hasValidPrice = computed(() => {
        const value = Number(displayPrice.value);
        return !Number.isNaN(value) && value > 0;
      });
      
      const bedrooms_string = (bedrooms) => {
        if (bedrooms == 0) {
          return 'Studio';
        } else {
          return bedrooms + ' ' + props.options.floor_plans_loop_bedrooms_label;
        }
      }

      const formatAvailableDate = (dateString) => {
        if (!dateString) return '';
        
        try {
          const date = new Date(dateString);
          return date.toLocaleDateString('en-US', { 
            month: 'short', 
            day: 'numeric', 
            year: 'numeric' 
          });
        } catch (e) {
          console.error('Error formatting date:', e);
          return dateString;
        }
      }

      return {
        bedrooms_string,
        formatAvailableDate,
        selectedLeaseOption,
        displayPrice,
        hasValidPrice,
        pricingOverrideText,
        showVrTourModal,
        openVrTourModal,
        closeVrTourModal,
        getLinkTargetAndRel
      };
    }
});
</script>